module.exports = "/dog-racing/img/dog-video.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/dog-video.png
// module id = 1953
// module chunks = 7